import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const RedirectComponent = ({ to }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (navigate) {
      navigate(to);
    }
  }, [navigate]);

  return <></>;
};

export default RedirectComponent;
